import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updatePage } from "../../api/apiPages";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

export const useUpdatePage = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";

    const { mutate: editPage, isLoading, isPending } = useMutation({
        mutationFn: ({ id, data }) => updatePage(id, data),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries(['pages']);
            queryClient.invalidateQueries(['page', id]);
            toast.success(isArabic ? "تم تحديث الصفحة بنجاح" : "Page updated successfully");
        },
        onError: (error) => {
            console.error("🚀 ~ useUpdatePage ~ error:", error);
            toast.error(isArabic ? "حدث خطأ أثناء تحديث الصفحة" : "Error updating page");
        },
    });

    return { editPage, isUpdating: isLoading || isPending };
};
